import React from 'react';
import { Check } from 'lucide-react';

// Step 3 of Register V2. Rendered only after signup()/loginWithGoogle()
// has already resolved successfully and the session is established —
// this component makes no auth calls of its own.
//
// P-AUTH-EMAIL-UX-1: `verifiedNote` adds a restrained "Adresse vérifiée."
// line above the heading — Register passes it only when this step was
// reached by CONFIRMING the verification e-mail (password path). The
// Google path keeps its previous screen pixel-identical.
export default function RegistrationSuccess({ headingRef, onContinue, verifiedNote = false }) {
  return (
    <div className="auth-confirm">
      <span className="auth-success-icon" aria-hidden="true"><Check size={24} /></span>
      {verifiedNote && <p className="auth-eyebrow" style={{ marginBottom: 8 }}>Adresse vérifiée.</p>}
      <h2 ref={headingRef} tabIndex={-1}>Votre compte est prêt.</h2>
      <p>Bienvenue sur NSARA. Vous pouvez maintenant accéder à votre espace.</p>
      <button type="button" className="auth-button auth-button-primary" onClick={onContinue}>
        Accéder à mon espace
      </button>
    </div>
  );
}
